import { gql } from '@apollo/client';

export const CREATE_FEEDBACK = gql`
    mutation CreateFeedback($input: CreateFeedbackInput!) {
        createFeedback(input: $input) {
            id
            collectionName
            docId
            contextType
            contextId
            feedbackReasons {
                id
                title
                value
                hasCustomValue
                enabled
            }
            feedbackSubReason
        }
    }
`;

export const UPDATE_FEEDBACK = gql`
    mutation UpdateFeedback($input: UpdateFeedbackInput!) {
        updateFeedback(input: $input) {
            id
            collectionName
            docId
            contextType
            contextId
            feedbackReasons {
                id
                title
                value
                hasCustomValue
                enabled
            }
            feedbackSubReason
        }
    }
`;
